import { make } from 'ts-brand';
import { convertArrayObjectKeysCase, convertObjectKeysCase } from '../case/case';
import { isArray } from '../hidash/hidash';
import type { CamelCase } from '../types';

export const objectToStrJson = <T extends ValidJson>(json: T): string => JSON.stringify(json);
export const strToObjectJson = <T extends ValidJson>(strJson: string): T => JSON.parse(strJson);

// Have to curry to pass down the generic
// @ts-expect-error Doing generic branded types with ts-brand takes a little ts suppression
const makeStrJson = <T extends ValidJson>(str: string) => make<SerializedJson<T>>()(str);

// @ts-expect-error Doing generic branded types with ts-brand takes a little ts suppression

const makeObjectJson = <T extends ValidJson>(object: T) => make<DeserializedJson<T>>()(object);

export const serializeJson = <T extends ValidJson>(json: T): SerializedJson<T> =>
  makeStrJson<T>(
    objectToStrJson(
      isArray(json) ? convertArrayObjectKeysCase(json, 'snakeCase') : convertObjectKeysCase(json, 'snakeCase'),
    ),
  );

/** Automatically will serialize snake case to camelcase since frontend always expects camelcase from api */
export const deserializeJson = <T extends ValidJson>(str: SerializedJson<T>): CamelCase<DeserializedJson<T>> => {
  // @ts-expect-error Doing generic branded types with ts-brand takes a little ts suppression
  const json = strToObjectJson(str as string);
  // @ts-expect-error Doing generic branded types with ts-brand takes a little ts suppression
  return makeObjectJson(
    isArray(json) ? convertArrayObjectKeysCase(json, 'camelCase') : convertObjectKeysCase(json, 'camelCase'),
  );
};
